export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/forte-icon.svg?ef1c62d5b5ee456feeda9c3a899fd091";